export enum DisputesHistoryDialogFieldLabelsEnum {
  UPDATED_DATE = 'Updated On',
  DISPUTE_STATUS = 'Status',
  UPDATED_BY = 'Updated By',
}
